import { CouponType } from 'types/coupon'
import { Action, Dispatch } from 'redux'
import { confirmCouponAction } from 'reducks/coupon/actions'
import { push } from 'connected-react-router'

const confirmCoupon = (coupon: CouponType) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(confirmCouponAction(coupon))
    dispatch(push('/admin/coupon/create/confirm'))
  }
}

export default confirmCoupon
